import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';

export interface SidebarCoacheesState {
	searchTerm: string;
}

@Injectable()
@StoreConfig({ name: 'ui-sidebar-coachees' })
export class SidebarCoacheesStore extends Store<SidebarCoacheesState> {
	constructor() {
		super({});
	}
}
